import type { TFunction } from 'i18next'
import { getTranslatedMarbleColor } from 'src/services/i18n/utils/gameTranslations'
import type { CalloutView } from './calloutState'
import { PUTTS_PER_ROUND, type Translate } from './tileViewModel'

export interface CalloutCopy {
  eyebrow: string
  word: string
}

/**
 * Literal keys only (the extractor cannot see a computed one). `Result` and
 * the four count labels already ship in all sixteen locales; the three new
 * strings are filled by `scripts/birdieLocales.mjs` and gated by
 * `birdieLocales.test.ts`.
 */
export function birdieCalloutCopy(view: CalloutView, t: Translate): CalloutCopy {
  if (view.kind === 'verdict') {
    return {
      eyebrow: t('Result'),
      word: getTranslatedMarbleColor(view.countKey, t as unknown as TFunction)
    }
  }
  return {
    eyebrow: t('Putt {{n}} of {{total}}', { n: view.putt, total: PUTTS_PER_ROUND }),
    word: view.kind === 'holed' ? t('Holed') : t('Missed')
  }
}
